import { useState } from 'react';

import { useShowCampaignSettings } from '@givebacks/api/store';
import { CellContext } from 'core';
import { Table } from 'core/Packages';
import { IconCopy, IconEditTabler, IconTrash, IconViewOn } from 'ui/Icons';

import { AddEditTicketModal } from '../AddEditTicket/AddEditTicketModal';
import { DeleteTicketModal } from '../AddEditTicket/DeleteTicketModal';
import { TicketTableData, TicketsTableInstance } from './tableInstance';

const TicketRowActions = (props: CellContext<TicketTableData, unknown>) => {
  const { table } = TicketsTableInstance.useContext();
  const { causeId, campaignId, ticketsType } = table.options.meta;

  const { data: campaignSettings } = useShowCampaignSettings({
    campaignId,
    causeId,
  });
  const { isCampaignReadOnly } = campaignSettings;

  const [openModal, setOpenModal] = useState<string | undefined>(undefined);
  const [isDuplicate, setIsDuplicate] = useState(false);

  return (
    <>
      <Table.RowAction>
        {isCampaignReadOnly ? (
          <Table.RowAction.Option
            label="View Ticket"
            icon={IconViewOn}
            onClick={() => setOpenModal('editTicket')}
          />
        ) : (
          <>
            <Table.RowAction.Option
              label="Edit Ticket"
              icon={IconEditTabler}
              onClick={() => setOpenModal('editTicket')}
            />
            <Table.RowAction.Option
              label="Duplicate Ticket"
              icon={IconCopy}
              onClick={() => {
                setIsDuplicate(true);
                setOpenModal('editTicket');
              }}
            />
            <Table.RowAction.Option
              label="Delete Ticket"
              icon={IconTrash}
              destructive
              onClick={() => setOpenModal('deleteTicket')}
              visible={campaignSettings.isCampaignDraft}
            />
          </>
        )}
      </Table.RowAction>
      <AddEditTicketModal
        opened={openModal === 'editTicket'}
        onClose={() => {
          setIsDuplicate(false);
          setOpenModal(undefined);
        }}
        ticketId={props.row.original.uuid}
        storeItemId={campaignId}
        causeId={causeId}
        isDuplicate={isDuplicate}
        isSeasonTicket={ticketsType === 'season_passes'}
      />
      <DeleteTicketModal
        causeId={causeId}
        campaignId={campaignId}
        opened={openModal === 'deleteTicket'}
        onClose={() => setOpenModal(undefined)}
        ticketId={props.row.original.uuid}
        isSeasonTicket={ticketsType === 'season_passes'}
      />
    </>
  );
};

export { TicketRowActions };
